import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon, UploadIcon } from 'lucide-react';
const SpouseAndFamily = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const [children, setChildren] = useState([{
    id: 1,
    name: '',
    age: ''
  }]);
  const [grandchildren, setGrandchildren] = useState([{
    id: 1,
    name: '',
    age: '',
    parent: ''
  }]);
  const maritalStatus = watch('clientInfo.maritalStatus');
  const addChild = () => {
    const newId = children.length > 0 ? Math.max(...children.map(c => c.id)) + 1 : 1;
    setChildren([...children, {
      id: newId,
      name: '',
      age: ''
    }]);
  };
  const removeChild = (id: number) => {
    setChildren(children.filter(child => child.id !== id));
  };
  const addGrandchild = () => {
    const newId = grandchildren.length > 0 ? Math.max(...grandchildren.map(g => g.id)) + 1 : 1;
    setGrandchildren([...grandchildren, {
      id: newId,
      name: '',
      age: '',
      parent: ''
    }]);
  };
  const removeGrandchild = (id: number) => {
    setGrandchildren(grandchildren.filter(grandchild => grandchild.id !== id));
  };
  return <div className="space-y-8" data-id="element-605">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-606">
        <p className="text-slate-700" data-id="element-607">
          Please provide information about your spouse, children, and other
          family members.
        </p>
      </div>
      {/* Spouse Information */}
      {(maritalStatus === 'married' || maritalStatus === 'commonLaw') && <div className="space-y-6" data-id="element-608">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-609">
            Spouse Information
          </h3>
          {/* Spouse Name */}
          <div data-id="element-610">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-611">
              Spouse's Name
              <span className="text-red-500 ml-1" data-id="element-612">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's full legal name" {...register('spouseInfo.name')} data-id="element-613" />
          </div>
          {/* Spouse Age */}
          <div data-id="element-614">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-615">
              Spouse's Age
            </label>
            <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your spouse's age" {...register('spouseInfo.age')} data-id="element-616" />
          </div>
        </div>}
      {/* Previous Marriages */}
      <div className="space-y-4" data-id="element-617">
        <div className="flex justify-between items-center" data-id="element-618">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-619">
            Previous Marriages
          </h3>
        </div>
        <div data-id="element-620">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-621">
            Have you been previously married?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-622">
            <label className="inline-flex items-center" data-id="element-623">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('previousMarriages.exists')} data-id="element-624" />
              <span className="ml-2" data-id="element-625">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-626">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('previousMarriages.exists')} data-id="element-627" />
              <span className="ml-2" data-id="element-628">No</span>
            </label>
          </div>
          {watch('previousMarriages.exists') === 'true' && <div data-id="element-629">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-630">
                Name of ex-spouse
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter name of ex-spouse" {...register('previousMarriages.exSpouseName')} data-id="element-631" />
            </div>}
        </div>
      </div>
      {/* Domestic Contracts */}
      <div className="space-y-4" data-id="element-632">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-633">
          Domestic Contracts
        </h3>
        <div data-id="element-634">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-635">
            Do you have any domestic contracts? (e.g., prenuptial agreement,
            separation agreement)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-636">
            <label className="inline-flex items-center" data-id="element-637">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('domesticContracts.exists')} data-id="element-638" />
              <span className="ml-2" data-id="element-639">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-640">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('domesticContracts.exists')} data-id="element-641" />
              <span className="ml-2" data-id="element-642">No</span>
            </label>
          </div>
          {watch('domesticContracts.exists') === 'true' && <div data-id="element-643">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-644">
                Upload domestic contract (optional)
              </label>
              <div className="border-2 border-dashed border-slate-300 rounded-md p-4 text-center" data-id="element-645">
                <UploadIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-646" />
                <p className="mt-2 text-sm text-slate-600" data-id="element-647">
                  Drag and drop your file here, or click to select
                </p>
                <input type="file" className="hidden" id="domestic-contract-upload" {...register('domesticContracts.file')} data-id="element-648" />
                <button type="button" onClick={() => document.getElementById('domestic-contract-upload')?.click()} className="mt-2 px-4 py-2 bg-navy-700 text-white text-sm rounded-md hover:bg-navy-800" data-id="element-649">
                  Select File
                </button>
              </div>
            </div>}
        </div>
      </div>
      {/* Support Obligations */}
      <div className="space-y-4" data-id="element-650">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-651">
          Support Obligations
        </h3>
        <div data-id="element-652">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-653">
            Do you have any support obligations? (e.g., child support, spousal
            support)
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-654">
            <label className="inline-flex items-center" data-id="element-655">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('supportObligations.exists')} data-id="element-656" />
              <span className="ml-2" data-id="element-657">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-658">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('supportObligations.exists')} data-id="element-659" />
              <span className="ml-2" data-id="element-660">No</span>
            </label>
          </div>
          {watch('supportObligations.exists') === 'true' && <div data-id="element-661">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-662">
                Details of support obligations
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter details of your support obligations" {...register('supportObligations.details')} data-id="element-663" />
            </div>}
        </div>
      </div>
      {/* Children */}
      <div className="space-y-4" data-id="element-664">
        <div className="flex justify-between items-center" data-id="element-665">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-666">
            Children
          </h3>
          <button type="button" onClick={addChild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-667">
            <PlusIcon size={16} className="mr-1" data-id="element-668" />
            Add Child
          </button>
        </div>
        {children.map((child, index) => <div key={child.id} className="p-4 bg-slate-50 rounded-md" data-id="element-669">
            <div className="flex justify-between items-center mb-3" data-id="element-670">
              <h4 className="font-medium" data-id="element-671">Child {index + 1}</h4>
              {children.length > 1 && <button type="button" onClick={() => removeChild(child.id)} className="text-red-500 hover:text-red-700" data-id="element-672">
                  <TrashIcon size={16} data-id="element-673" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-674">
              <div data-id="element-675">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-676">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's name" {...register(`children.${index}.name`)} data-id="element-677" />
              </div>
              <div data-id="element-678">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-679">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter child's age" {...register(`children.${index}.age`)} data-id="element-680" />
              </div>
            </div>
          </div>)}
      </div>
      {/* Grandchildren */}
      <div className="space-y-4" data-id="element-681">
        <div className="flex justify-between items-center" data-id="element-682">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-683">
            Grandchildren
          </h3>
          <button type="button" onClick={addGrandchild} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-684">
            <PlusIcon size={16} className="mr-1" data-id="element-685" />
            Add Grandchild
          </button>
        </div>
        {grandchildren.map((grandchild, index) => <div key={grandchild.id} className="p-4 bg-slate-50 rounded-md" data-id="element-686">
            <div className="flex justify-between items-center mb-3" data-id="element-687">
              <h4 className="font-medium" data-id="element-688">Grandchild {index + 1}</h4>
              {grandchildren.length > 1 && <button type="button" onClick={() => removeGrandchild(grandchild.id)} className="text-red-500 hover:text-red-700" data-id="element-689">
                  <TrashIcon size={16} data-id="element-690" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-691">
              <div data-id="element-692">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-693">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's name" {...register(`grandchildren.${index}.name`)} data-id="element-694" />
              </div>
              <div data-id="element-695">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-696">
                  Age
                </label>
                <input type="number" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter grandchild's age" {...register(`grandchildren.${index}.age`)} data-id="element-697" />
              </div>
              <div data-id="element-698">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-699">
                  Parent (Your Child)
                </label>
                <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register(`grandchildren.${index}.parent`)} data-id="element-700">
                  <option value="" data-id="element-701">Select parent</option>
                  {children.map(child => <option key={child.id} value={child.id} data-id="element-702">
                      {watch(`children.${children.findIndex(c => c.id === child.id)}.name`) || `Child ${child.id}`}
                    </option>)}
                </select>
              </div>
            </div>
          </div>)}
      </div>
      {/* Deceased Children */}
      <div className="space-y-4" data-id="element-703">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-704">
          Deceased Children
        </h3>
        <div data-id="element-705">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-706">
            Do you have any deceased children?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-707">
            <label className="inline-flex items-center" data-id="element-708">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('deceasedChildren.exists')} data-id="element-709" />
              <span className="ml-2" data-id="element-710">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-711">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('deceasedChildren.exists')} data-id="element-712" />
              <span className="ml-2" data-id="element-713">No</span>
            </label>
          </div>
          {watch('deceasedChildren.exists') === 'true' && <div data-id="element-714">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-715">
                Names of deceased children
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter names of deceased children" {...register('deceasedChildren.names')} data-id="element-716" />
            </div>}
        </div>
      </div>
    </div>;
};
export default SpouseAndFamily;